<template>
  <div class="page">
    <div class="cont" style="padding: 0.2rem 0">
      <header-body
        advertisingPosition="1"
        source="goods"
        style="padding: 0 0.3rem"
      ></header-body>
      <div class="taskImg" v-if="user.isAgent == '1' && taskShow">
        <img
          src="../img/task.gif"
          alt=""
          style="width: 100%; vertical-align: middle"
          @click="to()"
        />
      </div>
      <div class="tab" style="margin-top: 0; padding: 0 0.3rem">
        <div class="tabDiv">
          <div class="tabs" v-if="user.isAgent == '1'">
            <div
              class="tab_list"
              v-for="(item, i) in tabsD"
              :class="q.type == item.id ? 'tab_list_act' : ''"
              :key="item.id"
              :id="'sort_order' + item.id"
            >
              <p class="tab_color" @click="activeFn(i, item)">
                {{ item.value }}
                <span v-if="item.id == 0">
                  <img class="sot" alt style="width: 0" />
                </span>
                <span v-if="item.id == 1">
                  <img
                    class="sot"
                    v-if="
                      (q.sort == 0 || q.sort == 1 || q.sort == 2) && q.type != 1
                    "
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 0 && q.type == 1"
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 1 && q.type == 1"
                    @click.stop="imgFn"
                    src="../img/sot3.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 2 && q.type == 1"
                    @click.stop="imgFn"
                    src="../img/sot2.png"
                    alt
                  />
                </span>
                <span v-if="item.id == 2">
                  <img
                    class="sot"
                    v-if="
                      (q.sort == 0 || q.sort == 1 || q.sort == 2) && q.type != 2
                    "
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 0 && q.type == 2"
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 1 && q.type == 2"
                    @click.stop="imgFn"
                    src="../img/sot3.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 2 && q.type == 2"
                    @click.stop="imgFn"
                    src="../img/sot2.png"
                    alt
                  />
                </span>
                <span v-if="item.id == 3">
                  <img
                    class="sot"
                    v-if="
                      (q.sort == 0 || q.sort == 1 || q.sort == 2) && q.type != 3
                    "
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 0 && q.type == 3"
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 1 && q.type == 3"
                    @click.stop="imgFn"
                    src="../img/sot3.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 2 && q.type == 3"
                    @click.stop="imgFn"
                    src="../img/sot2.png"
                    alt
                  />
                </span>
              </p>
              <span class="line"></span>
            </div>
          </div>

          <div class="tabs" v-if="user.isAgent == '0'">
            <div
              class="tab_list"
              v-for="(item, i) in tabs"
              @click="activeFn(i, item)"
              :class="q.type == item.id ? 'tab_list_act' : ''"
              :key="item.id"
              :id="'sort_order' + item.id"
            >
              <p class="tab_color">
                {{ item.value }}
                <span v-if="item.id == 0">
                  <img class="sot" alt style="width: 0" />
                </span>
                <span v-if="item.id == 2">
                  <img
                    class="sot"
                    v-if="
                      (q.sort == 0 || q.sort == 1 || q.sort == 2) && q.type != 2
                    "
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 0 && q.type == 2"
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 1 && q.type == 2"
                    @click="imgFn"
                    src="../img/sot3.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 2 && q.type == 2"
                    @click.stop="imgFn"
                    src="../img/sot2.png"
                    alt
                  />
                </span>
                <span v-if="item.id == 3">
                  <img
                    class="sot"
                    v-if="
                      (q.sort == 0 || q.sort == 1 || q.sort == 2) && q.type != 3
                    "
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 0 && q.type == 3"
                    @click.stop="imgFn"
                    src="../img/sot1.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 1 && q.type == 3"
                    @click.stop="imgFn"
                    src="../img/sot3.png"
                    alt
                  />
                  <img
                    class="sot"
                    v-if="q.sort == 2 && q.type == 3"
                    @click.stop="imgFn"
                    src="../img/sot2.png"
                    alt
                  />
                </span>
              </p>
              <span class="line"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="items.length > 0" style="padding: 0 0.3rem">
        <waterfall :col="col" :data="items" @loadmore="onLoad">
          <div
            class="list"
            v-for="(item, i) in items"
            :key="i"
            @click="jumpUrl(item, i)"
            :id="'good_list' + i"
          >
            <img class="good_list" :src="item.picUrl ? item.picUrl : img" alt />
            <div class="goods_text_cont_x">
              <p class="goods_text_p">{{ item.goodsName | ellipsis }}</p>
              <div
                class="kanjia"
                v-if="item.bargainData.isBargain == '1'"
              >
              <div class="progress" v-if="item.bargainData.userBargainStatus != '0'">
                <span class="progress_out">
                    <span class="progress_in" :style="{width:item.bargainData.percentage+'%'}"></span>
                </span>
              </div>
                <div class="time">
                  距结束<date
                    :date="item.bargainData.restSeconds"
                    :index="i"
                    type="black2"
                  ></date>
                </div>
                <div class="yuanjia">
                  <p>原价&nbsp;<span>¥{{ item.bargainData.salePrice }}</span></p>
                  <p class="yongjin" v-show="user.isAgent == '1'&&item.integral>0">
                  <span style="text-decoration: unset;">+{{item.integral}}</span
                  >&nbsp;<img src="../img/jifen.png" alt style="width:0.22rem;height:0.22rem"/>
                </p>
                </div>
                <div class="kanjia-btn">
                  {{
                    item.bargainData.userBargainStatus == "0" ||
                    item.bargainData.userBargainStatus == "3"
                      ? `${item.bargainData.minPrice}元起抢购`
                      : "继续砍价"
                  }}
                </div>
              </div>
              <div class="goods_text_cont" v-else>
                <p class="goods_text goods_text_left">
                  ¥
                  <span>{{ item.price.split(".")[0] }}</span>
                  .{{ item.price.split(".")[1] }}
                </p>
                <p
                  class="goods_text goods_text_right"
                  v-if="user.isAgent == '1'&&item.integral>0"
                >
                  <span>+{{item.integral}}</span
                  >&nbsp;<img
                    class="good_list_img"
                    src="../img/jifen.png"
                    alt
                  />
                </p>
              </div>
            </div>
          </div>
        </waterfall>
        <van-divider v-if="finished">没有更多了</van-divider>
      </div>
      <div class="kong1" v-if="items.length == 0">
        <img src="../img/kong2.png" alt />
        <p>产品库正在升级调整中，尽请期待…</p>
      </div>

      <!-- 砍价记录 -->
      <div class="fixedBtn" id="kanjiajiluanniu" @click="log()" v-if="user.ifShowRecord == 1&&this.channelType !='assistant'">
        <img src="../img/position-right.png" alt="" style="width: 100%" />
      </div>

      <!-- 上架砍价活动提示 -->
      <van-popup v-model="shouyetishi" :close-on-click-overlay="false">
        <div class="wrapper shouyetishi" @click="close()" id="huodongshangjiatankuang">
          <div class="block" style="width: 6rem; margin: 0 auto 0.6rem">
            <img src="../img/shouyetishi.png" alt="" />
          </div>
          <img src="../img/close.png" style="width: 0.6rem" @click="close()" />
        </div>
      </van-popup>
    </div>
    <footer-body></footer-body>
  </div>
</template>

<script>
import footerBody from "../../common/footer/footer";
import headerBody from "../../common/header/header";
import getWXSign from "@/libs/wxSign";
import date from "../../common/date/date";

export default {
  name: "goodsHome",
  data() {
    return {
      check: false,
      items: [],
      col: 2,
      tabs: [
        { value: "默认", id: "0" },
        { value: "销量", id: "2" },
        { value: "价格", id: "3" },
      ],
      tabsD: [
        { value: "默认", id: "0" },
        { value: "佣金", id: "1" },
        { value: "销量", id: "2" },
        { value: "价格", id: "3" },
      ],
      q: {
        type: "0",
        sort: 0,
        page: "1",
        limit: "10",
      },
      loading: false,
      finished: false,
      img: require("../img/timg-21@2x.png"),
      user: null,
      time1: "",
      time2: "",
      dateDiff: "",
      taskShow: false,
      shouyetishi: false,
      isWexin: "",
      channelType:""
    };
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    },
  },
  components: {
    footerBody,
    headerBody,
    date,
  },
  mounted(){
this.$refs.progress.resize();
  },
  created() {
    let isPageHide = false;
    window.addEventListener('pageshow', function () {
        if (isPageHide) {
            window.location.reload();
        }
    });
    window.addEventListener('pagehide', function () {
        isPageHide = true;
    });
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.isWexin = sessionStorage.getItem("isWexin");
    this.taskList();
    this.goods();
    this.setShareHidden();

    this.setPoint();//首页埋点

    if (this.user.ifHaveBargain == "1") {
      let day = new Date().getDate();
      if (this.getCookie("getDate") != day) {
        this.shouyetishi = true;
        this.setcookie();
      } else {
        this.shouyetishi = false;
      }
    }
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 17) {
        return value.slice(0, 17) + "...";
      }
      return value;
    },
  },
  methods: {
    to() {
      this.$router.push("/taskList");
    },
    jumpUrl(item, i) {
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_list",
        card_type: "product_list",
        card_position: i + 1,
        material_id: item.skuNo,
        material_type: "product_id",
        material_link:
          item.goodsDetailType == "1"
            ? item.shanghaiDetailUrl
            : item.goodsDetailUrl,
        material_position: i + 1,
      });
      if (item.goodsDetailType == "1") {
        window.location.href = item.shanghaiDetailUrl;
      }
      if (item.goodsDetailType == "2") {
        window.location.href = item.goodsDetailUrl;
      }
    },


    //使用sensor1.22.6埋点 
    setPoint(){
        const source = {'assistant': '药店宝','wechat': '微信'}
        const typeWrap ={'1':'店员','2':'普通用户'}
        //用户id 用户名字 用户身份 所属社群id 社群名字 来源页面分类
        const {memberId, nickName, channelType,userType,communityId,communityName}= this.user
        this.$newTrackFn.send('FX_community_home_view', {
            member_id: memberId,
            user_name: nickName,
            user_type:typeWrap[userType],
            community_id:communityId,
            community_name:communityName,
            referrer_page_type: source[channelType] || '其他',
        });
    },

    taskList() {
      this.$api.taskList({ memberId: this.user.memberId }).then((res) => {
        if (res.errno == "0") {
          if (res.data.body.length != 0) this.taskShow = true;
        }
      });
    },
    goods() {
      this.$api.goodsPaging(this.q).then((res) => {
        this.items = this.items.concat(res.data.body);
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (res.data.body&&res.data.body.length < 10) {
          this.finished = true;
        }
        let { sellType,sellLabel,channel } = this.$route.query;
        this.items.forEach((item, index) => {
          this.$nextTick(() => {
            this.$trackFn.load("good_list" + index, "view_material", {
              // 曝光 - 埋点
              page_type: "good_list",
              card_type: "product_list",
              card_position: index + 1,
              material_id: item.skuNo,
              material_type: "product_id",
              material_link: item.goodsDetailUrl,
              material_position: index + 1,
            });
          });
        });
        this.$nextTick(() => {
            this.$trackFn.load("kanjiajiluanniu", "view_material", {
              // 曝光 - 埋点
              page_type: "good_list",
              card_type: "hover_button",
              sell_type:"retailstore",
              sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"hover_button",
              material_link:`${window.location.origin}/log`
            });
          });
          this.$nextTick(() => {
            this.$trackFn.load("huodongshangjiatankuang", "view_material", {
              // 曝光 - 埋点
              page_type: "good_list",
              card_type: "online_tips",
              sell_type:"retailstore",
              sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
              sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
              material_type:"online_tips"
            });
          });
        this.$nextTick(() => {
          this.$trackFn.load("sort_order0", "view_material", {
            // 曝光 - 埋点 默认按钮曝光/点击
            page_type: "good_list",
            card_type: "sort_order",
            card_position: 1,
            material_id: "comprehensive",
            material_type: "order_type",
            material_position: 1,
          });

          if (this.user.isAgent == "1") {
            this.$trackFn.load("sort_order1", "view_material", {
              // 曝光 - 埋点 佣金降序按钮曝光/点击
              page_type: "good_list",
              card_type: "sort_order",
              card_position: 1,
              material_id: "commission_desc",
              material_type: "order_type",
              material_position: 1,
            });
            this.$trackFn.load("sort_order1", "view_material", {
              // 曝光 - 埋点 佣金升序按钮曝光/点击
              page_type: "good_list",
              card_type: "sort_order",
              card_position: 1,
              material_id: "commission_asc",
              material_type: "order_type",
              material_position: 1,
            });
          }
          this.$trackFn.load("sort_order2", "view_material", {
            // 曝光 - 埋点 销量降序按钮曝光/点击
            page_type: "good_list",
            card_type: "sort_order",
            card_position: 1,
            material_id: "sale_desc",
            material_type: "order_type",
            material_position: 1,
          });
          this.$trackFn.load("sort_order2", "view_material", {
            // 曝光 - 埋点
            page_type: "good_list",
            card_type: "sort_order",
            card_position: 1,
            material_id: "sale_asc",
            material_type: "order_type",
            material_position: 1,
          });

          this.$trackFn.load("sort_order3", "view_material", {
            // 曝光 - 埋点 价格降序按钮曝光/点击
            page_type: "good_list",
            card_type: "sort_order",
            card_position: 1,
            material_id: "price_desc",
            material_type: "order_type",
            material_position: 1,
          });
          this.$trackFn.load("sort_order3", "view_material", {
            // 曝光 - 埋点
            page_type: "good_list",
            card_type: "sort_order",
            card_position: 1,
            material_id: "price_asc",
            material_type: "order_type",
            material_position: 1,
          });
        });

        let time1 = new Date().getTime();
        window.onbeforeunload = (e) => {
          let time2 = new Date().getTime();
          let dateDiff = (time2 - time1) / 1000;
          let page_type = "good_list";
          this.$trackFn.view("$pageview", {
            page_type: page_type,
            event_duration: dateDiff,
          }); // 商品列表页 ——浏览埋点
          sessionStorage.setItem("pageType", page_type);
          // return "关闭提示";
        };
      });
    },
    setShareHidden() {
      this.$bs.setShareHidden({ type: 1 }).then((e) => {
        if (e.status == "1") {
          this.$toast("开启成功");
        } else if (e.msg) {
          this.$toast(e.msg);
        }
      });
    },
    activeFn(i, item) {
      switch (item.id) {
        //   默认
        case "0":
          this.goodsClick(i, "comprehensive");
          break;
        //   佣金
        case "1":
          //   this.goodsClick(i, "comprehensive");
          break;
        //   销量
        case "2":
          break;
        //   价格
        case "3":
          break;

        default:
          break;
      }
      if (item.id === this.q.type) return false;
      this.q.type = item.id;
      this.q.page = 1;
      this.q.sort = 0;
      this.loading = false;
      this.finished = false;
      this.items = [];
      this.goods();
    },
    goodsClick(i, material_id) {
      console.log(22, i);
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_list",
        card_type: "sort_order",
        card_position: i + 1,
        material_id: material_id,
        material_type: "order_type",
        material_position: i + 1,
      });
    },
    imgFn() {
      if (this.q.type == "0") return false;
      this.q.page = 1;
      this.loading = false;
      this.finished = false;
      this.items = [];
      console.log(11, this.q.type, this.q.sort);
      switch (this.q.sort) {
        //   升序
        case 0:
          switch (this.q.type) {
            case "1":
              this.goodsClick(Number(this.q.type - 1), "commission_asc");
              break;
            case "2":
              this.goodsClick(Number(this.q.type - 1), "sale_asc");
              break;
            case "3":
              this.goodsClick(Number(this.q.type - 1), "price_asc");
              break;

            default:
              break;
          }
          this.q.sort = 1;
          break;
        //   降序
        case 1:
          switch (this.q.type) {
            case "1":
              this.goodsClick(Number(this.q.type - 1), "commission_desc");
              break;
            case "2":
              this.goodsClick(Number(this.q.type - 1), "sale_desc");
              break;
            case "3":
              this.goodsClick(Number(this.q.type - 1), "price_desc");
              break;

            default:
              break;
          }
          this.q.sort = 2;
          break;
        case 2:
          this.q.sort = 0;

          //   switch (this.q.type) {
          //     case "1":
          //       this.goodsClick(0, "comprehensive");
          //       break;
          //     case "2":
          //       break;
          //     case "3":
          //       break;

          //     default:
          //       break;
          //   }
          break;
        default:
          this.q.sort = 0;
          break;
      }
      this.goods();
    },
    onLoad() {
      this.q.page++;
      this.goods();
    },
    log() {
      this.$router.push("/log");
      let { sellType,sellLabel,channel } = this.$route.query;
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_list",
        card_type: "hover_button",
        sell_type:"retailstore",
        sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"hover_button",
        material_link:`${window.location.origin}/log`
      });
    },
    getMsgFormSon(index) {
      console.log("索引", index);
      this.items[index].bargainData.restSeconds = "0";
    },
    getCookie(key) {
      var arr1 = document.cookie.split("; "); //由于cookie是通过一个分号+空格的形式串联起来的，所以这里需要先按分号空格截断,变成[name=Jack,pwd=123456,age=22]数组类型；
      for (var i = 0; i < arr1.length; i++) {
        var arr2 = arr1[i].split("="); //通过=截断，把name=Jack截断成[name,Jack]数组；
        if (arr2[0] == key) {
          return decodeURI(arr2[1]);
        }
      }
    },
    setcookie() {
      let day = new Date().getDate();
      // d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
      // ad=popup-ad   键值对形式：name=key   expires 有效期
      document.cookie = `getDate=${day}`;
      let result = document.cookie;
      return result;
    },
    close() {
      this.shouyetishi = false;
      let { sellType,sellLabel,channel } = this.$route.query;
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "good_list",
        card_type: "online_tips",
        sell_type:"retailstore",
        sell_label:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'goodsid_yljkapp_yygw':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'goodsid_ydbapp_sy':"goodsid_wx_off",
        sell_from:JSON.parse(sessionStorage.getItem("user")).channelType == 'app'?'yljkapp':JSON.parse(sessionStorage.getItem("user")).channelType == 'assistant'?'ydbapp':"wx_off",
        material_type:"online_tips"
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cont {
  ::v-deep.van-popup {
    background-color: initial;
  }
}
.sot {
  position: relative;
  top: 6px;
  width: 40px;
  height: 40px;
}

.list {
  background: rgba(255, 255, 255, 1);
  margin-bottom: 30px;
  overflow: auto;
  height: 100%;
  border-radius: 0.12rem;
}

.kong1 {
  margin:30px 30px 0;
  padding:80px 0;
  background: #fff;
  text-align: center;
  border-radius: 16px;
}

.kong1 img {
  width: 270px;
  padding-bottom: 40px;
}

.kong1 p {
  font-size: 28px;
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(153, 153, 153, 1);
  // line-height: 34px;
}

.good_list {
  width: 100%;
  height: 280px;
  display: block;
}

.goods_text_p {
  /* text-align: justify;
  overflow: hidden; */
  /* text-overflow: ellipsis; */
  // display: -webkit-box;
  // -webkit-line-clamp: 2;
  // line-clamp: 2;
  font-size: 28px;
  color: #404040;
  /* -webkit-box-orient: vertical; */
  // height: 84px;
  margin-bottom: 15px;
}

.goods_text_cont_x {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.tab {
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  align-items: baseline;
}

.goods_text_cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.goods_text {
  display: flex;
  align-items: center;
}

.goods_text_left {
  color: #dd2b1e;
  font-size: 24px;
  align-items: baseline;
}

.goods_text_right {
  color: #ffa72e;
  background: rgba(255, 167, 46, 0.09);
  border-radius: 30px;
  height: 28px;
  justify-content: left;
  position: relative;
  top: 3px;
  padding: 4px 8px;
}
.goods_text_right span {
  font-size: 20px;
}
.goods_text_right img {
  width: 22px;
  height: 22px;
}

.goods_text_left span {
  font-size: 36px;
}

.tabs {
  display: flex;
}

.tab_list {
  padding-right: 80px;
}

.tab_list p {
  color: #999;
}

.tab_list:last-child {
  padding-right: 10px;
}

.tab_list p {
  font-size: 30px;
  padding: 24px 0;
}

.tab_list_act .line {
  width: 60px;
  height: 4px;
  background: rgba(221, 43, 30, 1);
  border-radius: 2px;
  display: block;
}

.tab_list_act .tab_color {
  color: rgba(221, 43, 30, 1);
}

.fixedBtn {
  position: fixed;
  right: 0;
  bottom: 1rem;
  width: 150px;
  height: auto;
  z-index: 9;
}
.kanjia {
  .time {
    color: #535353;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    .text {
      font-size: 20px;
    }
  }
  .progress{
    .progress_out{
    display:inline-block;
    width:100%;
    height:20px;
    background: #FFEEED;
    border-radius: 10px;
    position:relative;
    top:0;
    left:0;
    overflow: hidden;
    .progress_in{
        display:inline-block;
        height:20px;
        background: linear-gradient(135deg, #FFA000 0%, #FF6600 100%);
        border-radius: 10px;
        background-position:center right;
        position:absolute;
        top:0;
        left:0;
    }
}
  }
  .yuanjia {
    font-size: 22px;
    color: #999999;
    margin-bottom: 15px;
        display: flex;
    justify-content: space-between;
    span {
      font-size: 24px;
      text-decoration: line-through;
    }
    .yongjin{
      color: #ffa72e;
    background: rgba(255, 167, 46, 0.09);
    border-radius: 0.3rem;
    height: 0.28rem;
    padding: 0.04rem 0.08rem;
    display: flex;
    align-items: center;
    span{
      font-size: 20px;
    }
    }
  }
  .kanjia-btn {
    font-family: PingFangSC-Medium, PingFang SC;
    background: linear-gradient(135deg, #ffa000 0%, #ff6600 100%);
    box-shadow: 0px 8px 12px 0px rgba(224, 32, 32, 0.2);
    border-radius: 12px;
    color: #fff;
    font-size: 28px;
    text-align: center;
    padding: 16px 0;
    line-height: 1;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  // .block {
  //   margin: 0 0.8rem 0.6rem;
  //   padding: 0 0.48rem 0.42rem;
  //   background: rgba(255, 255, 255, 1);
  //   border-radius: 0.2rem;
  // }
  @media (min-device-width: 320px) and(max-device-width:414px) and(-webkit-min-device-pixel-ratio:2) {
    .block {
      margin-top: 1rem;
    }
  }
}
</style>
<style>
.vue-waterfall-column {
  width: calc(50% - 15px) !important;
  padding-left: 15px;
}
.vue-waterfall-column:nth-child(2){
  padding-right: 15px;
padding-left: 0;
}
</style>
